export default __webpack_public_path__ + "static/media/menu-tile1x.a1701900.png";